<div class="form-check">
  <input
    [id]="id()"
    data-cy="input"
    type="checkbox"
    [ngModel]="checked"
    [checked]="checked"
    [disabled]="disabled"
    class="form-check-input"
    (ngModelChange)="onModelChange($event)"
    [class.is-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
  />
  <label
    class="form-check-label"
    [for]="id()"
    [style]="labelStyles()"
    [innerHTML]="label() | safe"
  ></label>
</div>
